import apiClient from "./apiClient";

/**
 * Create a new Activity (Task, Meeting, Call, Note)
 * @param {string} companyCode
 * @param {object} payload - { employeeId, leadId, type, title, description, activityDate }
 */
export const createActivity = async (companyCode, payload) => {
  try {
    const res = await apiClient.post(
      "/api/activities",
      { ...payload, companyCode },
      {
        headers: companyCode ? { "x-active-company-code": companyCode } : {},
      }
    );
    return res;
  } catch (error) {
    console.error("[ActivityService] createActivity error:", error);
    return { success: false, message: error.message || "Failed to create activity" };
  }
};

/**
 * Get all activities (company-wide)
 * @param {string} companyCode
 * @param {object} params - { start, end }
 */
export const getAllActivities = async (companyCode, params = {}) => {
  try {
    const res = await apiClient.get("/api/activities", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("[ActivityService] getAllActivities error:", error);
    return { success: false, data: [] };
  }
};

/**
 * Get activities for a specific employee
 * @param {string} companyCode
 * @param {string} employeeId
 * @param {object} params - { start, end }
 */
export const getEmployeeActivities = async (companyCode, employeeId, params = {}) => {
  try {
    const res = await apiClient.get(`/api/activities/employee/${employeeId}`, {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("[ActivityService] getEmployeeActivities error:", error);
    return { success: false, data: [] };
  }
};

/**
 * Get activities for a specific lead
 * @param {string} companyCode
 * @param {string} leadId
 */
export const getLeadActivities = async (companyCode, leadId) => {
  try {
    const res = await apiClient.get(`/api/activities/lead/${leadId}`, {
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("[ActivityService] getLeadActivities error:", error);
    return { success: false, data: [] };
  }
};

/**
 * Update an existing activity
 * @param {string} companyCode
 * @param {string} activityId
 * @param {object} payload
 */
export const updateActivity = async (companyCode, activityId, payload) => {
  try {
    const res = await apiClient.put(
      `/api/activities/${activityId}`,
      { ...payload, companyCode },
      {
        headers: companyCode ? { "x-active-company-code": companyCode } : {},
      }
    );
    return res;
  } catch (error) {
    console.error("[ActivityService] updateActivity error:", error);
    return { success: false, message: error.message || "Failed to update activity" };
  }
};

/**
 * Get all activities scheduled for today (pending followups/calls/meetings)
 * @param {string} companyCode
 * @param {object} params - { employeeId }
 */
export const getTodayActivities = async (companyCode, params = {}) => {
  try {
    const res = await apiClient.get("/api/activities/today", {
      params,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("[ActivityService] getTodayActivities error:", error);
    return { success: false, data: [], count: 0 };
  }
};

